import { Tag} from "ant-design-vue";
const { ...other } = Tag;
const YwTag = {
  ...other,
  name: "YwTag",
};

YwTag.install = function (Vue) {
  Vue.component(YwTag.name,Tag);
};

export default YwTag;